import request from './request'

export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/admin/info',
    method: 'get'
  })
}

export function getMenus() {
  return request({
    url: '/admin/menus',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function getUserList(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

export function getUser(id) {
  return request({
    url: `/admin/user/${id}`,
    method: 'get'
  })
}

export function addUser(data) {
  return request({
    url: '/admin/user',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/admin/user',
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/admin/user/${id}`,
    method: 'delete'
  })
}

export function updateUserStatus(id, status) {
  return request({
    url: `/admin/user/status/${id}`,
    method: 'put',
    params: { status }
  })
}

export function bindUserRole(id, roleId) {
  return request({
    url: `/admin/user/role/${id}`,
    method: 'put',
    params: { roleId }
  })
}

export function updateUserContract(id, data) {
  return request({
    url: `/admin/user/contract/${id}`,
    method: 'put',
    params: data
  })
}

export function exportUserList(params) {
  return request({
    url: '/admin/user/export',
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}

export function getRoleOptions() {
  return request({
    url: '/admin/role/options',
    method: 'get'
  })
}

// 账户管理（H5用户）
export function h5AddAccount(data) {
  return request({
    url: '/admin/h5/account/add',
    method: 'post',
    data
  })
}

export function h5GetAccountList() {
  return request({
    url: '/admin/h5/account/list',
    method: 'get'
  })
}

export function h5GetAccount(id) {
  return request({
    url: `/admin/h5/account/${id}`,
    method: 'get'
  })
}

export function h5UpdateAccount(id, data) {
  return request({
    url: `/admin/h5/account/update/${id}`,
    method: 'put',
    data
  })
}

export function h5DeleteAccount(id) {
  return request({
    url: `/admin/h5/account/delete/${id}`,
    method: 'delete'
  })
}

// 地址管理（H5用户）
export function h5AddAddress(data) {
  return request({
    url: '/admin/h5/address/add',
    method: 'post',
    data
  })
}

export function h5GetAddressList() {
  return request({
    url: '/admin/h5/address/list',
    method: 'get'
  })
}

export function h5GetAddress(id) {
  return request({
    url: `/admin/h5/address/${id}`,
    method: 'get'
  })
}

export function h5UpdateAddress(id, data) {
  return request({
    url: `/admin/h5/address/update/${id}`,
    method: 'put',
    data
  })
}

export function h5DeleteAddress(id) {
  return request({
    url: `/admin/h5/address/delete/${id}`,
    method: 'delete'
  })
}

export function h5SetDefaultAddress(id) {
  return request({
    url: `/admin/h5/address/setDefault/${id}`,
    method: 'put'
  })
}

// 管理员账户管理
export function getAccountList(params) {
  return request({
    url: '/admin/account/list',
    method: 'get',
    params
  })
}

export function getAccount(id) {
  return request({
    url: `/admin/account/${id}`,
    method: 'get'
  })
}

export function updateAccountStatus(id, status) {
  return request({
    url: `/admin/account/status/${id}`,
    method: 'put',
    params: { status }
  })
}

export function deleteAccount(id) {
  return request({
    url: `/admin/account/${id}`,
    method: 'delete'
  })
}

// 地址管理
export function getAddressList(params) {
  return request({
    url: '/admin/address/list',
    method: 'get',
    params
  })
}

export function getAddress(id) {
  return request({
    url: `/admin/address/${id}`,
    method: 'get'
  })
}

export function updateAddressStatus(id, status) {
  return request({
    url: `/admin/address/status/${id}`,
    method: 'put',
    params: { status }
  })
}

export function deleteAddress(id) {
  return request({
    url: `/admin/address/${id}`,
    method: 'delete'
  })
}

// 活动管理
export function getActivityList(params) {
  return request({
    url: '/admin/activity/list',
    method: 'get',
    params
  })
}

export function getActivity(id) {
  return request({
    url: `/admin/activity/get/${id}`,
    method: 'get'
  })
}

export function addActivity(data) {
  return request({
    url: '/admin/activity/add',
    method: 'post',
    data
  })
}

export function updateActivity(id, data) {
  return request({
    url: `/admin/activity/update/${id}`,
    method: 'put',
    data
  })
}

export function deleteActivity(id) {
  return request({
    url: `/admin/activity/delete/${id}`,
    method: 'delete'
  })
}

export function updateActivityStatus(id, status) {
  return request({
    url: `/admin/activity/status/${id}`,
    method: 'put',
    params: { status }
  })
}

// 今日好卡图片上传（走 /api/admin/upload/activity，type=card）
export function uploadCardImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', 'card')
  return request({
    url: '/admin/upload/activity',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ==================== 运单管理 ====================

export function getExpressList(params) {
  return request({
    url: '/admin/express/list',
    method: 'get',
    params
  })
}

export function addExpress(data) {
  return request({
    url: '/admin/express/add',
    method: 'post',
    params: data
  })
}

export function getExpressUsers() {
  return request({
    url: '/admin/express/users',
    method: 'get'
  })
}

export function getAllAddresses() {
  return request({
    url: '/admin/express/addresses',
    method: 'get'
  })
}

export function getShelfCodes(userId) {
  return request({
    url: '/admin/express/shelf-codes',
    method: 'get',
    params: { userId }
  })
}

export function getExpress(id) {
  return request({
    url: `/admin/express/${id}`,
    method: 'get'
  })
}

export function updateExpress(id, data) {
  return request({
    url: `/admin/express/${id}`,
    method: 'put',
    params: data
  })
}

export function deleteExpress(id) {
  return request({
    url: `/admin/express/${id}`,
    method: 'delete'
  })
}

export function checkExpressOrderNo(orderNo, excludeId) {
  return request({
    url: '/admin/express/checkOrderNo',
    method: 'get',
    params: { orderNo, excludeId }
  })
}

export function uploadExpressImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/admin/express/upload/image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ==================== 上拍管理 ====================

export function getAuctionList(params) {
  return request({
    url: '/admin/auction/list',
    method: 'get',
    params
  })
}

export function getAuction(id) {
  return request({
    url: `/admin/auction/${id}`,
    method: 'get'
  })
}

export function addAuction(data) {
  return request({
    url: '/admin/auction/add',
    method: 'post',
    params: data
  })
}

export function updateAuction(id, data) {
  return request({
    url: `/admin/auction/${id}`,
    method: 'put',
    params: data
  })
}

export function deleteAuction(id) {
  return request({
    url: `/admin/auction/${id}`,
    method: 'delete'
  })
}

export function getAuctionUsers() {
  return request({
    url: '/admin/auction/users',
    method: 'get'
  })
}

export function getAuctionStats(params) {
  return request({
    url: '/admin/auction/stats',
    method: 'get',
    params
  })
}

export function importAuction(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/admin/auction/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function downloadAuctionTemplate() {
  return request({
    url: '/admin/auction/template',
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadUserTemplate() {
  return request({
    url: '/admin/user/template',
    method: 'get',
    responseType: 'blob'
  })
}

export function importUser(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/admin/user/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadActivityImage(file, type) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  return request({
    url: '/admin/upload/activity',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ==================== 角色管理 ====================

export function getRoleList(params) {
  return request({
    url: '/admin/role/list',
    method: 'get',
    params
  })
}

export function getRole(id) {
  return request({
    url: `/admin/role/${id}`,
    method: 'get'
  })
}

export function addRole(data) {
  return request({
    url: '/admin/role',
    method: 'post',
    params: data
  })
}

export function updateRole(id, data) {
  return request({
    url: `/admin/role/${id}`,
    method: 'put',
    params: data
  })
}

export function deleteRole(id) {
  return request({
    url: `/admin/role/${id}`,
    method: 'delete'
  })
}

export function getRoleMenus(roleId) {
  return request({
    url: `/admin/role/${roleId}/menus`,
    method: 'get'
  })
}

export function bindRoleMenus(roleId, menuIds) {
  return request({
    url: `/admin/role/${roleId}/menus`,
    method: 'put',
    data: menuIds
  })
}

export function getMenuTree() {
  return request({
    url: '/admin/menu/tree',
    method: 'get'
  })
}

export function getMenuTreeAll() {
  return request({
    url: '/admin/menu/treeAll',
    method: 'get'
  })
}

export function getMenu(id) {
  return request({
    url: `/admin/menu/${id}`,
    method: 'get'
  })
}

export function addMenu(data) {
  return request({
    url: '/admin/menu',
    method: 'post',
    data
  })
}

export function updateMenu(id, data) {
  return request({
    url: `/admin/menu/${id}`,
    method: 'put',
    data
  })
}

export function deleteMenu(id) {
  return request({
    url: `/admin/menu/${id}`,
    method: 'delete'
  })
}

// ==================== 今日好卡 ====================

export function getCardList(params) {
  return request({
    url: '/admin/card/list',
    method: 'get',
    params
  })
}

export function getCard(id) {
  return request({
    url: `/admin/card/${id}`,
    method: 'get'
  })
}

export function addCard(data) {
  return request({
    url: '/admin/card',
    method: 'post',
    data
  })
}

export function updateCard(id, data) {
  return request({
    url: `/admin/card/${id}`,
    method: 'put',
    data
  })
}

export function deleteCard(id) {
  return request({
    url: `/admin/card/${id}`,
    method: 'delete'
  })
}

export function updateCardStatus(id, status) {
  return request({
    url: `/admin/card/status/${id}`,
    method: 'put',
    params: { status }
  })
}

// ==================== 回款订单管理 ====================

export function getRemittanceList(params) {
  return request({
    url: '/admin/remittance/list',
    method: 'get',
    params
  })
}

export function getRemittance(id) {
  return request({
    url: `/admin/remittance/${id}`,
    method: 'get'
  })
}

export function addRemittance(data) {
  return request({
    url: '/admin/remittance/add',
    method: 'post',
    params: data
  })
}

export function updateRemittance(id, data) {
  return request({
    url: `/admin/remittance/${id}`,
    method: 'put',
    data
  })
}

export function deleteRemittance(id) {
  return request({
    url: `/admin/remittance/${id}`,
    method: 'delete'
  })
}

export function exportRemittanceList(params) {
  return request({
    url: '/admin/remittance/export',
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}

// ==================== 优惠券管理 ====================

export function getCouponList(params) {
  return request({
    url: '/admin/coupon/list',
    method: 'get',
    params
  })
}

export function getCoupon(id) {
  return request({
    url: `/admin/coupon/${id}`,
    method: 'get'
  })
}

export function getCouponStats(id) {
  return request({
    url: `/admin/coupon/${id}/stats`,
    method: 'get'
  })
}

export function getCouponIssueUsers(id, params) {
  return request({
    url: `/admin/coupon/${id}/issues`,
    method: 'get',
    params
  })
}

export function addCoupon(data) {
  return request({
    url: '/admin/coupon',
    method: 'post',
    data
  })
}

export function updateCoupon(id, data) {
  return request({
    url: `/admin/coupon/${id}`,
    method: 'put',
    data
  })
}

export function deleteCoupon(id) {
  return request({
    url: `/admin/coupon/${id}`,
    method: 'delete'
  })
}

export function updateCouponStatus(id, status) {
  return request({
    url: `/admin/coupon/status/${id}`,
    method: 'put',
    params: { status }
  })
}

export function restockCoupon(id, amount) {
  return request({
    url: `/admin/coupon/restock/${id}`,
    method: 'put',
    params: { amount }
  })
}

// ==================== 优惠券发放记录管理 ====================

export function getCouponIssueList(params) {
  return request({
    url: '/admin/coupon/issue/list',
    method: 'get',
    params
  })
}

export function getCouponIssue(id) {
  return request({
    url: `/admin/coupon/issue/${id}`,
    method: 'get'
  })
}

export function addCouponIssue(data) {
  return request({
    url: '/admin/coupon/issue',
    method: 'post',
    data
  })
}

export function updateCouponIssue(id, data) {
  return request({
    url: `/admin/coupon/issue/${id}`,
    method: 'put',
    data
  })
}

export function deleteCouponIssue(id) {
  return request({
    url: `/admin/coupon/issue/${id}`,
    method: 'delete'
  })
}

export function importRemittance(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/admin/remittance/import',
    method: 'post',
    data: formData,
    timeout: 600000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ==================== 提现记录管理 ====================

export function getWithdrawList(params) {
  return request({
    url: '/admin/withdraw/list',
    method: 'get',
    params
  })
}

export function getWithdraw(id) {
  return request({
    url: `/admin/withdraw/${id}`,
    method: 'get'
  })
}

export function approveWithdraw(id) {
  return request({
    url: `/admin/withdraw/approve/${id}`,
    method: 'put'
  })
}

export function rejectWithdraw(id, reason) {
  return request({
    url: `/admin/withdraw/reject/${id}`,
    method: 'put',
    params: { reason }
  })
}

export function deleteWithdraw(id) {
  return request({
    url: `/admin/withdraw/${id}`,
    method: 'delete'
  })
}

export function batchApproveWithdraw(ids) {
  return request({
    url: '/admin/withdraw/batch/approve',
    method: 'post',
    data: ids
  })
}

export function exportWithdrawList() {
  return request({
    url: '/admin/withdraw/export',
    method: 'get',
    responseType: 'blob'
  })
}
